import React from 'react';
import './Modal.css';

function Modal({ isOpen, onClose, children, contentClassName = '' }) {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={`modal-content ${contentClassName}`.trim()} onClick={(e) => e.stopPropagation()}>
        <button className="modal-close-button" onClick={onClose}>&times;</button>
        {children}
      </div>
    </div>
  );
}

export default Modal;
